// extracted by mini-css-extract-plugin
module.exports = {"createGroupButtonContainer":"License-tab_createGroupButtonContainer_13Nw2"};